/**
 * Created by pajicv on 10/2/18.
 */
import { isLoaded } from 'react-redux-firebase';
import { branch, renderComponent } from 'recompose';
import LoadingProgress from '../components/common/LoadingProgress';

export const spinnerWhile = condition =>
    branch(condition, renderComponent(LoadingProgress));

export const spinnerWhileLoading = propNames =>
    spinnerWhile(props => {
        const isOn = propNames.reduce((result, name) => result && isLoaded(props[name]), true);
        return !isOn;
    });



// WEBPACK FOOTER //
// ./src/utils/components.js